import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, NavigateContext, M_Table } from 'src/M_Components'

export const EblPartyNameList = ({ roles, tablesOrder = [], onTablesOrderUpdate }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const [refresh, setRefresh] = useState(false)

    const NewRoute = (url, label, operation, data) => {
        if (data !== undefined) {
            ctx.passValue?.set('operation', operation)
            ctx.passValue?.set('row', data)
            ctx2.newTab(url, label)
        }
    }

    return (
        <M_Table
            entityName={'eblPartyName'}
            rolePermissions={roles}
            tablesOrder={tablesOrder}
            onTablesOrderUpdate={onTablesOrderUpdate}
            pageUrl={'eblPartyNames'}
            replaceFunctions={new Map([
                ['Create', () => NewRoute('go/eblPartyNameDetail', t('Create eBL Party Name'), 'create', {})],
                ['Edit', (data) => NewRoute('go/eblPartyNameDetail', t('Edit eBL Party Name'), 'edit', data)]
            ])}
            refresh={refresh}
            setRefresh={setRefresh}
        />
    )
}
